<template>
  <span :style="styles"></span>
</template>

<script>
export default {
  name: 'BaseSpacer',
  props: {
    size: {
      type: [String, Number],
      default: '2rem',
    },
  },
  computed: {
    styles() {
      return {
        display: 'block',
        height: Number.isNaN(Number(this.size)) ? this.size : `${this.size}px`,
      };
    },
  }
}
</script>